import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("ellipse", {
  cx: 26,
  cy: 47,
  rx: 26,
  ry: 5,
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 31.145c0-.141 0-.283.002-.424.155-8.835 7.442-15.873 16.277-15.719C35.021 15.155 42.003 22.293 42 31v14.222a1.968 1.968 0 0 1-1.766 1.967c-2.882.29-8.819.812-14.233.812-5.415 0-11.352-.522-14.234-.812a1.968 1.968 0 0 1-1.766-1.967V31.144z",
  fill: "#73C4FF"
});

var _ref3 =
/*#__PURE__*/
___EmotionJSX("path", {
  stroke: "#73C4FF",
  strokeWidth: 3,
  strokeLinecap: "round",
  d: "M26.5 1.5v6M45.363 9.121l-4.242 4.243M10.242 13.363L5.999 9.121"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 52,
    height: 52,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/faq-serious.ef95c7a4.svg";
export { SvgComponent as ReactComponent };